export * from './carrinho-menu/carrinho-menu.modal';
export * from './completa-endereco/completa-endereco.modal';
export * from './completar-cadastro/completar-cadastro.modal';
export * from './identificacao/identificacao.modal';
export * from './loja-menu/loja-menu.modal';
export * from './pedido-detalhes/pedido-detalhes.modal';
export * from './produto-detalhes/produto-detalhes.modal';
export * from './seleciona-endereco/seleciona-endereco.modal';
